import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const FilterOptionSelect = styled.div`
    position: relative;
    padding: 10px 0 20px 0;
    ${media.mobileDevice`
        padding: 0;
    `}
`;

export const FilterContainer = styled.div`
    background-color: (props.backgroundColor ? props.backgroundColor : '#ffffff')};
    display: flex;
    font-family: AvenirNextWorld Regular;
    font-size: 14px;
    color: #140f4b;
    justify-content: flex-start;
    & span {
        font-family: 'AvenirNextWorld Demi';
        margin-left: ${(props) =>
            props.marginLeft ? props.marginLeft : '5px'};
    }

    ${media.mobileDevice`
        flex-direction: column;
        padding:
        ${(props) =>
            props.filterContainerMobilePadding
                ? props.filterContainerMobilePadding
                : '10px 16px 10px'};
        border-top-left-radius:${(props) =>
            props.noMobileBorder ? 'unset' : '20px'};
        border-top-right-radius: ${(props) =>
            props.noMobileBorder ? 'unset' : '20px'};
        border-bottom-left-radius:0px;
        border-bottom-right-radius:0px;
        margin:${(props) =>
            props.mobileMargin ? props.mobileMargin : '0 0 -1px 0'};
        box-shadow: none;
        min-height: auto;
        align-items: flex-start;
        background-color: ${({ mobileBackgroundColor }) =>
            mobileBackgroundColor ? mobileBackgroundColor : '#ffffff'};
        width: ${(props) => (props.mobileWidth ? props.mobileWidth : '100%')};
    `}
`;

export const ViewContainer = styled.div`
    margin: 0 10px;
    flex-basis: 10%;
    display: flex;
    align-items: center;
    & span {
        font-family: AvenirNextWorld Demi;
        white-space: nowrap;
    }

    ${media.mediumDevice`
        flex-basis: ${(props) =>
            props.flexBasisStyle ? props.flexBasisStyle : '20%'};
    `}
`;

export const FilterDetailsContainer = styled.div`
    display: flex;
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0px')};

    max-width: 100%;
    overflow: ${(props) => (props.overflow ? props.overflow : 'hidden')};
    white-space: nowrap;
    text-overflow: ellipsis;
    align-content: center;
    align-items: center;
    &::-webkit-scrollbar {
        display: none;
    }

    ${media.mobileDevice`
        margin: 0px;
        width: ${({ mobileWidth }) => (mobileWidth ? mobileWidth : '98%')};
        margin-top: ${(props) =>
            props.mobileMargin
                ? 'unset'
                : props.marginTop
                ? props.marginTop
                : '10px'};
    `}
`;

export const ExtraContainer = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: #1010eb;
    font-size: 12px;
    align-items: center;
    justify-content: center;
    line-height: 25px;
    cursor: pointer;
    &::-webkit-scrollbar {
        display: none;
    }

    ${media.mobileDevice`
        background-color: transparent;
        border-left: 0;
        border-right: 0;
        font-family: AvenirNextWorld Demi;
    `}
`;

export const FilterStringWithPipe = styled.p`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex: 1;
    margin: 0 0 0 5px;
    padding: 0;
    font-family: AvenirNextWorld Demi;
    font-size: 12px;
    text-align: left;
    color: #140f4b;
    align-content: center;
    align-items: center;
    width: ${(props) => (props.filtersWidth ? '491px' : 'unset')};
    ${media.mobileDevice`
    width: ${(props) => (props.filtersWidth ? '491px' : props.mbViewWidth ? 'calc(100vw - 76px)' :'unset')};
    `}
`;

export const ClearFilterDesktop = styled.span`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    cursor: pointer;
    // padding-top: 1px;
    color: #1010eb;
    display: flex;
    text-align: right;
    margin-left: 15px;
    ${media.mobileDevice`
        font-size: 12px;
        cursor: pointer;
        padding-top: 1px;
        width: 100%;
        margin-left: 0px;
        justify-content: flex-start;
    `}
`;
export const ClearFilterMobile = styled.span`
    display: none;
    ${media.mobileDevice`
        display:flex;
        font-family: 'AvenirNextWorld Demi';
        font-size: 12px;
        cursor: pointer;
        padding-top: 1px;
        color: #1010eb;
        width: 100%;
        justify-content: end;
    `}
`;
